import React, { useEffect } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import SelectBusinessType from '../components/mill-sheet-search/SelectBusinessType';
import SelectSteelCategory from '../components/mill-sheet-search/SelectSteelCategory';
import AddOrganizationCondition from '../components/mill-sheet-search/AddOrganizationCondition';
import ManageSearchOptions from '../components/mill-sheet-search/ManageSearchOptions';
import MillsheetDownload from '../components/mill-sheet-search/MillSheetDownload';
import MillSheetCount from '../components/mill-sheet-search/MillSheetCount';
import MillSheetGrid from '../components/mill-sheet-search/MillSheetGrid';
import { useTranslation } from 'react-i18next';
import useUserRoles from '../hooks/useUserRoles';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetMessage } from '../redux/slices/millSheetSearch';
import {
  getSteelMakerOptions,
  getBusinessTypeOptions,
  getSteelCategoryOptions,
  getSteelCategoryTypeOptions,
  getCustomer1Options,
  getCustomer2Options,
  getCustomer3Options,
  getLanguageOptions,
  getTradingCompanyOptions,
  getOrganizationBaseOptions,
} from '../redux/slices/options';
import { getOrganizations } from '../redux/slices/organization';
import { getDeliveryLocations } from '../redux/slices/deliveryLocation';

const MillsheetSearch = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.millSheetSearch);
  const { isAdminOrPoweruser } = useUserRoles();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 初期データ取得
  useEffect(() => {
    dispatch(getSteelMakerOptions());
    dispatch(getBusinessTypeOptions());
    dispatch(getSteelCategoryOptions());
    dispatch(getSteelCategoryTypeOptions());
    dispatch(getCustomer1Options());
    dispatch(getCustomer2Options());
    dispatch(getCustomer3Options());
    dispatch(getLanguageOptions());
    dispatch(getTradingCompanyOptions());
    dispatch(getDeliveryLocations());
    // なりすまし検索パーツのためのデータ取得
    if (isAdminOrPoweruser) {
      dispatch(getOrganizationBaseOptions());
      dispatch(getOrganizations());
    }
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="12" md="3" title={t('millSheet.search')} subtitle="Mill Sheet Search" className="text-sm-left" />
        <Col sm="6" md="3">
          <SelectBusinessType />
        </Col>
        <Col sm="6" md="3">
          <SelectSteelCategory />
        </Col>
        <Col sm="12" md="3" className="d-flex justify-content-end">
          <AddOrganizationCondition />
        </Col>
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row form>
        <ManageSearchOptions />
      </Row>

      <Row form>
        <Col md="10" className="form-group">
          <MillsheetDownload />
        </Col>
        <Col md="2" className="d-flex justify-content-end align-items-end">
          <MillSheetCount />
        </Col>
      </Row>

      <MillSheetGrid />
    </Container>
  );
};

export default MillsheetSearch;
